module.exports = __webpack_public_path__ + "static/media/dt-next.82606180.svg";